export const toMapById = list => {
  return list.reduce((acc, option) => {
    acc[option.id] = option;
    return acc;
  }, {});
};
